module.exports = __webpack_public_path__ + "static/media/deliveryIcon.c75f5122.svg";